import { BooleanType } from '../enums/boolean-type';

export class BooleanTypeEntity {
  public constructor(
    public readonly key: BooleanType,
    public readonly label: string,
  ) {}
}
